export const forgotPasswordText = 'Forgot password?';
export const loginText = 'Login';
export const continueText = 'Continue';
export const orText = 'or';
export const loggedInSuccessfullyText = 'Logged in successfully, redirecting....';
export const signInWithText = 'signin_with';
export const choosePlatformText = 'Choose platform';
export const passwordExpiredText = 'Your password has expired.';
export const clickHereToResetItText = 'Click here to reset it';
export const titleText = 'BeeHero';
export const somethingWentWrongText = 'Oops... something went wrong';
export const mixpanelLoginEvent = {
    USER_EMAIL: 'User Email',
    SIGN_IN_METHOD: 'Sign In Method',
    SIGN_IN_TYPE: 'Sign In Type',
    GOOGLE_SIGN_IN: 'Google Sign In',
    GOOGLE: 'Google',
    SUCCESS: 'Success',
    FAILURE: 'Failure'
};
